import React, { useState, useEffect } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WorkIcon from '@mui/icons-material/Work';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import Autocomplete from '@mui/material/Autocomplete';

const UserProfile = () => {
  const [selectedState, setSelectedState] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedProfession, setSelectedProfession] = useState('');
  const [estados, setEstados] = useState([]);
  const [cities, setCities] = useState([]);
  const navigate = useNavigate();

  const professions = [
    'Pedreiro',
    'Ajudante de Pedreiro',
    'Doméstica',
    'Cuidador de Idoso',
    'Babá',
    'Capinador',
    'Bombeiro',
    'Eletricista',
    'Carpinteiro',
    'Serralheiro',
    'Montador de Moveis',
    'Segurança',
    'Garçon',
    'Entregador',
    'Professo Particular',
    'Pintor',
    'Programador',
    'Fotógrafo',
    'Personal Trainner',
    'Contador',
    'Gesseiro',
  ];

  // Buscar estados ao carregar o componente
  useEffect(() => {
    fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
      .then(res => res.json())
      .then(data => setEstados(data));
  }, []);

  // Buscar cidades ao selecionar o estado
  useEffect(() => {
    if (selectedState) {
      fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${selectedState}/municipios`)
        .then(res => res.json())
        .then(data => setCities(data));
    } else {
      setCities([]);
    }
  }, [selectedState]);

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button
          variant="text"
          color="secondary"
          size="small"
          startIcon={<WorkIcon />}
          onClick={() => navigate('/login')}
          sx={{ textTransform: 'none', fontWeight: 500 }}
        >
          Você já tem cadastro? Faça login.
        </Button>
      </Box>
      <Typography variant="h4" gutterBottom align="center" sx={{ mb: 4 }}>
        Encontre o Profissional Ideal para Você
      </Typography>

      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Filtre sua busca
          </Typography>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              select
              label="Estado"
              value={selectedState}
              onChange={(e) => {
                setSelectedState(e.target.value);
                setSelectedCity('');
              }}
              fullWidth
              InputProps={{
                startAdornment: <LocationOnIcon sx={{ mr: 1, color: 'primary.main' }} />
              }}
            >
              {estados.map((estado) => (
                <MenuItem key={estado.id} value={estado.sigla}>
                  {estado.nome}
                </MenuItem>
              ))}
            </TextField>

            <Autocomplete
              options={cities}
              getOptionLabel={(option) => option.nome || ''}
              value={cities.find(city => city.nome === selectedCity) || null}
              onChange={(event, newValue) => setSelectedCity(newValue ? newValue.nome : '')}
              disabled={!selectedState}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Cidade"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <LocationOnIcon sx={{ mr: 1, color: 'primary.main' }} />
                    ),
                  }}
                />
              )}
            />

            <TextField
              select
              label="Profissão"
              value={selectedProfession}
              onChange={(e) => setSelectedProfession(e.target.value)}
              fullWidth
              InputProps={{
                startAdornment: <WorkIcon sx={{ mr: 1, color: 'primary.main' }} />
              }}
            >
              {professions.map((profession) => (
                <MenuItem key={profession} value={profession}>
                  {profession}
                </MenuItem>
              ))}
            </TextField>

            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              fullWidth
              sx={{ mt: 2 }}
              disabled={!selectedState || !selectedCity || !selectedProfession}
              onClick={() => navigate(`/search?state=${selectedState}&city=${selectedCity}&profession=${selectedProfession}`)}
            >
              Buscar Profissionais
            </Button>
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            É um profissional?
          </Typography>
          <Typography variant="body1" paragraph>
            Cadastre-se em nossa plataforma e encontre novos clientes!
          </Typography>
          <Button 
            variant="outlined" 
            color="primary" 
            size="large"
            fullWidth
            startIcon={<PersonIcon />}
            onClick={() => navigate('/register/professional')}
          >
            Cadastre-se como Profissional
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default UserProfile; 